import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RecintoModel } from '../models/RecintoModel';
import { obtenerRecintos } from '../../../../service/recintos/Recintos';

export const useObtenerRecintos = (reload: number) => {
  const [list, setList] = useState<RecintoModel[]>([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const res = await obtenerRecintos().catch(() => history.push('/error/500'));
      if (res) {
        setList(res.rows);
        setLoading(false);
      }
    };
    fetch();
  }, [reload]);

  return { list, loading };
};

export const useObtenerRecintoPorID = (id: number) => {
  const initModel: RecintoModel = { id: 0, nombre: '', direccion: '', aforo_max: 0 };
  const [initValues, setInitValues] = useState<RecintoModel>(initModel);
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    if (id > 0) {
      import('../../../../service/recintos/Recintos').then(({ obtenerRecintos }) =>
        obtenerRecintos()
          .then((data) => {
            const found = data.rows.find((r: RecintoModel) => r.id === id);
            if (found) setInitValues(found);
          })
          .catch(() => history.push('/error/500'))
          .finally(() => setLoadingRequest(false))
      );
    } else {
      setInitValues(initModel);
      setLoadingRequest(false);
    }
  }, [id]);

  return { initValues, loadingRequest };
};
